import { Component, Input, OnChanges } from '@angular/core';
import { HospitalNames } from '@shared/models/hospitalTypes.model';
import { Profile } from '../../models/profile.model';
import { UserService } from '../../services/user.service';
import { getSurgeonSpecialtiesNameBySelectedHospitals } from '../../utils/cross-functions';

@Component({
  selector: 'app-specialties-hover',
  templateUrl: './specialties-hover.component.html',
  styleUrls: ['./specialties-hover.component.scss'],
  standalone: false,
})
export class SpecialtiesHoverComponent implements OnChanges {
  @Input() public profile: Profile | undefined;

  @Input() public isProfile: boolean = false;

  @Input() public tinyMode: boolean = false;

  @Input() public isStatopView: boolean = false;

  @Input() public basicProfile: boolean = false;

  @Input() public showHover: boolean = true;

  public isMultiHospital: boolean = false;

  public isMultiSpecialties: boolean = false;

  public isHovered: boolean = false;

  public specialtiesName: string[] = [];

  public fullSpecialtiesName: string = '';

  public isTooLong: boolean = false;

  public hospitalNames: HospitalNames;

  constructor(private userService: UserService) {
    this.hospitalNames = this.userService.getHospitalNames();
  }

  ngOnChanges() {
    if (this.profile) {
      const selectedHospitalsId = this.userService.getSelectedHospitals();
      this.isMultiHospital = selectedHospitalsId.length >= 2;
      this.specialtiesName = [];
      this.fullSpecialtiesName = '';
      this.specialtiesName = getSurgeonSpecialtiesNameBySelectedHospitals(this.profile, selectedHospitalsId);
      this.specialtiesName.forEach((name: string) => {
        if (this.fullSpecialtiesName.length > 0) {
          this.fullSpecialtiesName += ', ';
        }
        this.fullSpecialtiesName += name;
      });
      if (!this.isProfile && !this.tinyMode) {
        this.isTooLong = this.fullSpecialtiesName.length > 23;
      } else if (this.tinyMode) {
        this.isTooLong = this.fullSpecialtiesName.length > 28;
      } else {
        this.isTooLong = this.fullSpecialtiesName.length > 18;
      }
      this.isMultiSpecialties = this.specialtiesName.length >= 2;
    }
  }

  onMouseOver() {
    if (!this.showHover) {
      return;
    }
    this.isHovered = true;
    setTimeout(() => {
      this.isHovered = false;
    }, 3000);
  }

  onMouseOut() {
    this.isHovered = false;
  }
}
